// extracted by mini-css-extract-plugin
export default {"root":"searchbar_root__pyp5n","input":"searchbar_input__mT5tK"};